<template>
  <ValidationObserver class="needs-validation form-custom-format " v-bind:class="{'was-validated' : validated}" tag="form" ref="observer" v-slot="{passes}" @submit.prevent="onSubmitForm()">
       <ThatsWindow ref="window" title="Foreign Currency" windowClass="Foreigncurrency height-auto" scrollClass='Foreigncurrency height-auto' @deleteYes="emitDelete" :width="650" :group="group" :formStatus="FormStatus" @dialog-state="dialogState">
         <template #left-button>
            <template v-if="formLoading">
              <mdb-btn color="elegant" size="sm" disabled>
                <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                Loading...
              </mdb-btn>
            </template>
            <template v-else>
              <mdb-btn color="elegant" size="sm" @click="passes(onSubmitForm)">Save</mdb-btn>
              <!-- <mdb-btn color="elegant" class="ml-0"  size="sm">Save & New</mdb-btn> -->
            </template>
          
            
         </template>
         
         <mdbContainer class="mt-4">
             <mdb-row >

              <mdb-col col="10">
                  <ThatsSeriesInput labelClass="col-md-3" fieldClass="col-md-4 pl-0" label="Foreign Currency ID" placeholder="Foreigncurrency Code" vid="series" name="series" v-model="form.series" :validated="validated" :rules="'required'" size="sm" :disabled="true" />                  
                  <ThatsInput  labelClass="col-md-3" fieldClass="col-md-9 pl-0" label="Currency Code" vid="name" name="name" v-model="form.name" :validated="validated" :rules="'required'" size="sm" />
                   <ThatsInput  labelClass="col-md-3" fieldClass="col-md-9 pl-0" label="Currency by Country" vid="currencycountry" name="currencycountry" v-model="form.currencycountry" :validated="validated" :rules="'required'" size="sm" />
                  <ThatsInput  labelClass="col-md-3" fieldClass="col-md-9 pl-0" label="Currency Symbol" vid="currencysymbol" name="currencysymbol" v-model="form.currencysymbol" :validated="validated" :rules="''" size="sm" />
              

              </mdb-col>

              


              
             </mdb-row>
         
          
          </mdbContainer>
        
       </ThatsWindow>

      <ImageGrid ref="upload" :multiple="false" @select="fnImageSelect" :group="2"></ImageGrid>

  </ValidationObserver>
</template>
<script>
import { mdbBtn,mdbContainer,mdbSelect, mdbRow,mdbCol} from "mdbvue";
import { ValidationObserver } from "vee-validate";
import { mapActions,mapGetters, mapMutations } from 'vuex'
import {ThatsInput, ThatsTextarea, ThatsSeriesInput, ThatsCheckbox,ThatsFieldset, ThatsWindow, ThatsRadio, ThatsMultiSelect, ThatsAutocomplete,ThatsImage} from '../../components/thats/Thats'
import ImageGrid from '../../components/image/ImageGrid'
// import ImageUpload from '../../components/image/ImageUpload'

export default {
    name : "ForeignCurrencyForm",
    components: {
        mdbContainer,
        ValidationObserver,
        ThatsWindow, 
        ThatsInput,  
        ThatsTextarea,  
        ThatsSeriesInput,  
        ThatsCheckbox,  
        ThatsFieldset,
        ThatsRadio,
        ThatsMultiSelect,
        ThatsAutocomplete,
        ThatsImage,
        mdbBtn,
        mdbRow,
        // ImageUpload,
        ImageGrid,
        mdbCol  
        
  },
    
props : {
      group : {
            type : Number,
            default : 1
        },
    },
    data : () => ({
      validated : false,
      form : null,
      response : {
        error : null,
        message : null
      },
      formLoading : false,

      area : [],
      brands : [],
      category : [],

      status : [
            { status : "Probationary", code : "probationary"},
            { status : "Active", code : "active"},
            { status : "Resigned", code : "resigned"}, 
            { status : "Terminated", code : "terminated"},
          ]
    }),

    created : function() {

      if(this.FormStatus == 'create'){
        this.form = this.formVar();
      } 
      
      this.optionsHandler()
    },
    methods: {
      ...mapActions('CategoryModule',[ 'GetCategory' ]),
      ...mapActions('AreaModule',[ 'GetArea' ]),
      ...mapActions('BrandModule',[ 'GetBrands' ]),
      ...mapActions('ForeigncurrencyModule',[
        'StoreRecord',
        'UpdateRecord',
        'GetNextCode',
      ]),
      ...mapMutations('ForeigncurrencyModule',[
        'SetFormStatusCreate',
      ]),

      formVar(){
        return {
          series : 0,
          name : null,
          currencycountry : null,
          currencysymbol : null,
          reference : '',
          description : null,
          image : [],
          attr : {
            address : null,
            email : null,
          },
          status : 'active'
        }
      },
/* start */
      onSelectBrand(v){
        this.form.category = null
         this.GetCategory({brand : v}).then(response => {
            const category = [];
            response.forEach(element => {
              category.push({category : element.label,code : element.value})
            });
            this.category = category
          });

      },

      optionsHandler(){


        if(this.brands.length <= 0){

          this.GetBrands().then(response => {
            const brands = [];
            response.forEach(element => {
              brands.push({brand : element.label,code : element.value})
            });
            this.brands = brands
          });

          /*
          
          [
            { status : "Active", code : "active"},
            { status : "Void", code : "void"},
          ]
          
          */
        }


      },
      
      uploadImage(){
        this.$refs.upload.openDialog();
      },

      nextCode(){
        var self = this;
        this.GetNextCode().then((response) => {
          self.form.series = response.code
        });
      },

      demo(v){
        console.log(v)
      },

/* end */
      openDialog(){
            this.$refs.window.openDialog()
      },
      closeDialog(){
          this.$refs.window.closeDialog()
      },
      fnImageSelect(v){
        this.form.image = v
      },
      onSubmitForm(){
        var self =this
            this.validated = true
            const isValid = this.$refs.observer.validate();
            if (isValid) {
                // this.form.description = this.getText();
                    if(self.formLoading === false){
                      self.formLoading = true
                      if(self.FormStatus == 'create'){
                          self.StoreRecord(self.form).then((response) => {
                              self.$ThatsNotify.success()
                              self.$emit('success',response)
                              self.closeDialog();
                              self.FormResetter();

                            }).catch((error) => {
                              self.formLoading = false
                              self.response.error = 1;
                              if (error.response) {
                                  if(error.response.data.hasOwnProperty('errors')){
                                    self.$refs.observer.setErrors(error.response.data.errors);
                                  }
                                } else if (error.request) {
                                    self.response.message = error.request
                                } else {
                                    self.response.message = error.message
                                }
                                return;
                            })
                      }

                      if(self.FormStatus == 'update'){
                          self.UpdateRecord(self.form).then((response) => {
                              self.$ThatsNotify.success({
                                message : "Record was successfully updated"
                              })
                                self.closeDialog();
                                self.$emit('success',response)
                                self.FormResetter();
                                

                            }).catch((error) => {
                              self.formLoading = false
                              self.response.error = 1;
                              if (error.response) {
                                  if(error.response.data.hasOwnProperty('errors')){
                                    self.$refs.observer.setErrors(error.response.data.errors);
                                  }
                                } else if (error.request) {
                                    self.response.message = error.request
                                } else {
                                    self.response.message = error.message
                                }
                                return;
                            })
                      }
                    }
                    
            }        
      },

      getText() {
        let text = this.$refs.descriptionEditor.$children;
        text = text.$el.innerHTML;
        return text;
      },
      FormResetter(){
        this.form = this.formVar()
        requestAnimationFrame(() => {
              this.$refs.observer.reset();
            });
        this.validated = false
        this.formLoading = false
        this.SetFormStatusCreate();
      },
      
      dialogState(state){
        if(!state){
          this.FormResetter();
          return
        }

        if(this.FormStatus == 'create'){
            this.nextCode();
        }

        this.optionsHandler();

      },
      emitDelete(){
        this.$emit('delete',this.FormRecord)
      }

    },

    computed: {

      ...mapGetters('ForeigncurrencyModule',
      [
        'FormStatus',
        'FormRecord',
      ]),
    },

    watch: {
      FormRecord : function(){
        if(this.FormStatus == 'update'){
          this.form = JSON.parse(JSON.stringify(this.FormRecord.row));
        }
      },

/*       "form.name" : function(val) {

        if(val !== null){
          const res = val.substring(0, 4)
          this.form.short = res.toUpperCase();
        }
      } */

      /* area : {
        immediate : true,
        handler(){
          this.areaHandle();
        }
        
      } */
    },


}
</script>

<style scoped>
.click-to-add-logo{
  font-size: 14px;cursor: pointer;
}
</style>